// Original workflow diagram: process redesign chain rendered as connected nodes.
const STEPS = [
  { k: "01", label: "Frame the decision" },
  { k: "02", label: "Map the process" },
  { k: "03", label: "Redesign" },
  { k: "04", label: "Apply intelligence" },
  { k: "05", label: "Deliver & adopt" },
  { k: "06", label: "Measure" },
];

export function WorkflowDiagram({ compact = false }) {
  return (
    <div className="w-full" data-testid="workflow-diagram" role="img" aria-label="ThinkStack process redesign method: frame, map, redesign, apply intelligence, deliver and adopt, measure">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-[#E5E5E5] border border-[#E5E5E5]">
        {STEPS.map((s, i) => (
          <div key={s.k} className="relative bg-white p-5 md:p-6 group hover:bg-off-white transition-colors">
            <span className="overline text-restrained-blue">{s.k}</span>
            <p className="mt-3 font-serif text-lg md:text-xl leading-tight text-deep-navy">{s.label}</p>
            {i < STEPS.length - 1 && (
              <span className="hidden lg:block absolute right-[-1px] top-1/2 w-2 h-2 border-t border-r border-restrained-blue rotate-45 -translate-y-1/2 bg-white" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
